// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
  font-family: "Playfair Display" !important;
}
.about-body {
  font-family: "Playfair Display" !important;
}
.about-body {
  font-family: "Helvetica Neue" !important;
  opacity: 60% !important;
  font-size: 20px !important;
  font-weight: 300 !important;
  padding-bottom: 20px !important;
  line-height: 29px !important;
}

.location-head {
  color: var(--Black, #000) !important;
  font-family: "Playfair Display" !important;
  font-size: 20px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
}

.location-sub {
  color: var(--Black, #000) !important;
  font-family: "Playfair Display" !important;
  font-size: 32px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
  padding-bottom: 20px;
  padding-top: 10px;
}

.img-col {
  background-repeat: no-repeat;
  background-size: cover;
}

.about-des-box {
  padding-right: 30px !important;
}

.bg-image-col {
  padding-left: 30px !important;
}

.box-1 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start !important;
  /* height: 113px !important; */
  margin-top: 1rem;
  width: 184px;
  text-align: left !important;
}

.box-2 {
  /* height: 150px !important; */
  display: flex !important;
  flex-direction: column !important;
  justify-content: flex-start !important;
  margin-top: 1rem;
  /* height: 113px !important; */
  margin-top: 1rem;
  width: 401px;
  text-align: left !important;
  /* padding-left: 28px !important; */
}

.about-container {
  margin-top: 0rem !important;
  margin-bottom: 4rem !important;
}

/* .bg-image-col {
  margin-left: 1rem !important;
} */

.boxs-border-cards {
  display: flex;
}

.boxs-border-cards {
  display: flex;
  justify-content: flex-start;
  gap: 121px;
  margin-bottom: 12px;
  border-radius: 10px;
  border: 1px solid var(--Primary, #313b2f);
  padding-left: 20px;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 44px;
}

@media only screen and (max-width: 390px) {
  /* .about-grid-mobile-boxes {
    margin-top: -32rem !important;
  } */
}
@media only screen and (min-width: 768px) and (max-width: 768px) {
  .boxs-border-cards {
    display: flex;
    justify-content: flex-start;
    gap: 67px;
    margin-bottom: 12px;
    border-radius: 10px;
    border: 1px solid var(--Primary, #313b2f);
    padding-left: 20px;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 44px;
    width: 678px !important;
  }
}
@media only screen and (min-width: 500px) and (max-width: 600px) {
  .boxs-border-cards {
    display: flex;
    justify-content: flex-start;
    gap: 67px;
    margin-bottom: 12px;
    border-radius: 10px;
    border: 1px solid var(--Primary, #313b2f);
    padding-left: 20px;
    align-items: flex-start;
    padding-top: 24px;
    padding-bottom: 44px;
    width: 104% !important;
    flex-direction: column;
  }
  .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-3.MuiGrid-grid-xl-5.css-1q9c3ht-MuiGrid-root {
    max-height: 550px;
  }

  .about-des-box {
    flex-basis: 100.666667% !important;
    flex-grow: 0;
    max-width: 100.666667% !important;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1199px) {
  .about-des-box {
    flex-basis: 100.666667% !important;
    flex-grow: 0;
    max-width: 100.666667% !important;
  }

  .boxs-border-cards {
    display: flex;
    justify-content: flex-start;
    gap: 67px;
    margin-bottom: 12px;
    border-radius: 10px;
    border: 1px solid var(--Primary, #313b2f);
    padding-left: 20px;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 44px;
    width: 100%;
  }
  .css-bwvw8j-MuiGrid-root {
    flex-basis: 100.666667% !important;
    flex-grow: 0;
    max-width: 100.666667% !important;
  }
}
@media only screen and (max-width: 500px) {
  .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-3.MuiGrid-grid-xl-5.css-1q9c3ht-MuiGrid-root {
    max-height: 550px;
  }

  /* .about-grid-mobile-boxes {
    margin-top: -19rem !important;
  } */
  .boxs-border-cards {
    display: flex;
  }
  .boxs-border-cards {
    display: flex;
    gap: 44px;
    flex-direction: column;
    width: 312px;
    align-items: flex-start;
    padding-left: 29px;
    max-width: 100%;
  }
}

.about {
  font-family: "Playfair Display" !important;
  text-transform: uppercase;
  font-size: 16px !important;
  width: 80%;
}

.bg-image-col:hover,
.bg-image-col:focus {
  transform: scale(1.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutComponent.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;GAEG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;;KAEG;AACL;AACA;EACE;IACE,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;;EAEA;IAGE,kCAAkC;IAIlC,YAAY;IACZ,iCAAiC;EACnC;AACF;;AAEA;EACE;IAGE,kCAAkC;IAIlC,YAAY;IACZ,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;EACb;EACA;IAGE,kCAAkC;IAIlC,YAAY;IACZ,iCAAiC;EACnC;AACF;AACA;EACE;IACE,iBAAiB;EACnB;;EAEA;;KAEG;EACH;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;AACvB","sourcesContent":[".about {\n  font-family: \"Playfair Display\" !important;\n}\n.about-body {\n  font-family: \"Playfair Display\" !important;\n}\n.about-body {\n  font-family: \"Helvetica Neue\" !important;\n  opacity: 60% !important;\n  font-size: 20px !important;\n  font-weight: 300 !important;\n  padding-bottom: 20px !important;\n  line-height: 29px !important;\n}\n\n.location-head {\n  color: var(--Black, #000) !important;\n  font-family: \"Playfair Display\" !important;\n  font-size: 20px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n}\n\n.location-sub {\n  color: var(--Black, #000) !important;\n  font-family: \"Playfair Display\" !important;\n  font-size: 32px !important;\n  font-style: normal !important;\n  font-weight: 500 !important;\n  line-height: normal !important;\n  padding-bottom: 20px;\n  padding-top: 10px;\n}\n\n.img-col {\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.about-des-box {\n  padding-right: 30px !important;\n}\n\n.bg-image-col {\n  padding-left: 30px !important;\n}\n\n.box-1 {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start !important;\n  /* height: 113px !important; */\n  margin-top: 1rem;\n  width: 184px;\n  text-align: left !important;\n}\n\n.box-2 {\n  /* height: 150px !important; */\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: flex-start !important;\n  margin-top: 1rem;\n  /* height: 113px !important; */\n  margin-top: 1rem;\n  width: 401px;\n  text-align: left !important;\n  /* padding-left: 28px !important; */\n}\n\n.about-container {\n  margin-top: 0rem !important;\n  margin-bottom: 4rem !important;\n}\n\n/* .bg-image-col {\n  margin-left: 1rem !important;\n} */\n\n.boxs-border-cards {\n  display: flex;\n}\n\n.boxs-border-cards {\n  display: flex;\n  justify-content: flex-start;\n  gap: 121px;\n  margin-bottom: 12px;\n  border-radius: 10px;\n  border: 1px solid var(--Primary, #313b2f);\n  padding-left: 20px;\n  align-items: center;\n  padding-top: 20px;\n  padding-bottom: 44px;\n}\n\n@media only screen and (max-width: 390px) {\n  /* .about-grid-mobile-boxes {\n    margin-top: -32rem !important;\n  } */\n}\n@media only screen and (min-width: 768px) and (max-width: 768px) {\n  .boxs-border-cards {\n    display: flex;\n    justify-content: flex-start;\n    gap: 67px;\n    margin-bottom: 12px;\n    border-radius: 10px;\n    border: 1px solid var(--Primary, #313b2f);\n    padding-left: 20px;\n    align-items: flex-start;\n    padding-top: 20px;\n    padding-bottom: 44px;\n    width: 678px !important;\n  }\n}\n@media only screen and (min-width: 500px) and (max-width: 600px) {\n  .boxs-border-cards {\n    display: flex;\n    justify-content: flex-start;\n    gap: 67px;\n    margin-bottom: 12px;\n    border-radius: 10px;\n    border: 1px solid var(--Primary, #313b2f);\n    padding-left: 20px;\n    align-items: flex-start;\n    padding-top: 24px;\n    padding-bottom: 44px;\n    width: 104% !important;\n    flex-direction: column;\n  }\n  .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-3.MuiGrid-grid-xl-5.css-1q9c3ht-MuiGrid-root {\n    max-height: 550px;\n  }\n\n  .about-des-box {\n    -webkit-flex-basis: 66.666667%;\n    -ms-flex-preferred-size: 66.666667%;\n    flex-basis: 100.666667% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100.666667% !important;\n  }\n}\n\n@media only screen and (min-width: 600px) and (max-width: 1199px) {\n  .about-des-box {\n    -webkit-flex-basis: 66.666667%;\n    -ms-flex-preferred-size: 66.666667%;\n    flex-basis: 100.666667% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100.666667% !important;\n  }\n\n  .boxs-border-cards {\n    display: flex;\n    justify-content: flex-start;\n    gap: 67px;\n    margin-bottom: 12px;\n    border-radius: 10px;\n    border: 1px solid var(--Primary, #313b2f);\n    padding-left: 20px;\n    align-items: flex-start;\n    padding-top: 20px;\n    padding-bottom: 44px;\n    width: 100%;\n  }\n  .css-bwvw8j-MuiGrid-root {\n    -webkit-flex-basis: 66.666667%;\n    -ms-flex-preferred-size: 66.666667%;\n    flex-basis: 100.666667% !important;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    max-width: 100.666667% !important;\n  }\n}\n@media only screen and (max-width: 500px) {\n  .MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.MuiGrid-grid-sm-3.MuiGrid-grid-xl-5.css-1q9c3ht-MuiGrid-root {\n    max-height: 550px;\n  }\n\n  /* .about-grid-mobile-boxes {\n    margin-top: -19rem !important;\n  } */\n  .boxs-border-cards {\n    display: flex;\n  }\n  .boxs-border-cards {\n    display: flex;\n    gap: 44px;\n    flex-direction: column;\n    width: 312px;\n    align-items: flex-start;\n    padding-left: 29px;\n    max-width: 100%;\n  }\n}\n\n.about {\n  font-family: \"Playfair Display\" !important;\n  text-transform: uppercase;\n  font-size: 16px !important;\n  width: 80%;\n}\n\n.bg-image-col:hover,\n.bg-image-col:focus {\n  transform: scale(1.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
